import { RecommendationItemAdditionalContentProps } from "../../recommendations";
import React from "react";
import { RecommendationListItemAdditionalContent } from "../RecommendationListItemAdditionalContent";
import { AwsRecommendationSummary } from "../../../../../../customer-experience/src/v2/src/features/recommendations-feature/utils/recommendationTypes";
import { parseArnToListItemResource } from "../../utils/awsRecommendationsUtils";

export const AwsListItemAdditionalContent = ({
  recommendation,
}: RecommendationItemAdditionalContentProps<AwsRecommendationSummary>) => {
  let totalResources;
  let displayedResources: any[];
  const isSecurityRecommendation =
    recommendation.sourceMetadata?.securitySpecificMetadata;

  if (isSecurityRecommendation) {
    const securityMetadata =
      recommendation.sourceMetadata.securitySpecificMetadata;
    const resourceIds = securityMetadata?.resourceIds || [];
    totalResources = resourceIds.length;

    displayedResources = resourceIds
      .slice(0, 5)
      .map((arn: string) => parseArnToListItemResource(arn));
  } else {
    totalResources =
      recommendation.affectedScopes?.reduce(
        (total, sub) => total + (sub.affectedResources?.length || 0),
        0,
      ) || 0;

    displayedResources =
      recommendation.affectedScopes
        ?.flatMap((sub) => sub.affectedResources || [])
        .slice(0, 5) || [];
  }

  if (totalResources === 0) {
    return null;
  }

  return (
    <RecommendationListItemAdditionalContent
      displayedResources={displayedResources}
      totalResources={totalResources}
    />
  );
};
